/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'cms/CmsText'
import { attachStyle, getDeepValue } from 'cms/helpers/styledComponents'
const COMPONENT = 'staticPrice'

const PriceText = styled(Text) `
  ${({ theme, strikethrough }) => (
    attachStyle(strikethrough, getDeepValue(theme, 'cms', COMPONENT, 'discount'))
  )}
`

const StaticPrice = ({
  price,
  strikethrough,
  hasSymbol,
  symbol,
  children,
  className,
  ...props
}) => (
  <PriceText
    as="span"
    className={`static-price ${className}`}
    size={props.size}
    strikethrough={strikethrough}
    {...props}
  >
    {hasSymbol && symbol} {price.toLocaleString('en-US', { minimumFractionDigits: 2 })}
    {children}
  </PriceText>
)

StaticPrice.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  className: PropTypes.string,
  hasSymbol: PropTypes.bool,
  color: PropTypes.string,
  symbol: PropTypes.string,
  strikethrough: PropTypes.bool,
  children: PropTypes.node,
  size: PropTypes.string,
}
StaticPrice.defaultProps = {
  price: 0,
  className: '',
  color: 'black',
  hasSymbol: false,
  symbol: '฿',
  strikethrough: false,
  children: [],
  size: 'tiny',
}

export default StaticPrice



// WEBPACK FOOTER //
// ./src/cms/components/productCard/StaticPrice.js